module.exports = {
  dataLayer: async (data) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push(data);
    }
  },
  trackEvent: (event, options) => {
    options = options || {};
    event = event + "_mkbsd";
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({ event, ...options });
    }
  }
}